import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

class NonconformityForm extends Component {
	constructor(props) {
		super(props);
//		"id": 1,
//		"title": "nonconformity 1",
//		"description": "nonconformity description",
//		"correctiveAction": "",
//		"isueDate": "2020-11-24T15:46:31.000+0000",
//		"correctionDate": null
		this.state={ 
			title: this.props.title,
			description: this.props.description,
			correctiveAction: this.props.correctiveAction,
			correctionDate: this.props.correctionDate
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.correctiveAction = this.correctiveAction.bind(this);
		this.closeIsue = this.closeIsue.bind(this);
		this.formButtons = this.formButtons.bind(this);
		this.save = this.save.bind(this);
	}
	
	
	handleChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		this.setState({[e.target.name]: e.target.value });
	}
	handleSubmit(e) {
		e.preventDefault();
		this.props.saveNonconformity(this.state, false);
	}
	handleClose(e){
		e.preventDefault();
		this.props.saveNonconformity(this.state, true);
	}
	correctiveAction(){
		if(this.props.id>0){
			return <Grid item>
					<textarea
						onChange={this.handleChange}
						style={{width: "100%"}}
						rows="4"
						id="correctiveAction"
						name="correctiveAction"
						value={this.state.correctiveAction}
					/>
				</Grid>
		}else{
			return "";
		}
	}
	formButtons(){
		return  <Grid container item direction="row" alignItems="stretch" justify="flex-start" spacing={2} xs={12}>
					{this.save()}
					{this.closeIsue()}
				</Grid>
	}
	closeIsue(){
		if(this.props.id>0 && this.props.role=="ADMIN"){
			return <Grid item xs={6}>
						<Box m={1}>
						<Button variant="contained" color="primary" aria-label="Close" onClick={this.handleClose.bind(this)}>
							Save & Close isue
						</Button>
						</Box>
					</Grid>;
		}else{
			return "";
		}
	}
	save(){
		return <Grid item  xs={6}>
					<Box m={1}>
					<Button variant="contained" color="primary" aria-label="Save" onClick={this.handleSubmit.bind(this)}>
						Save
					</Button>
					</Box>
				</Grid>;
	}
	render() {
		let ncIdDesc=this.props.id>0?" [ "+this.props.id+" ]":"";
		
		return (
			<div class="contentM">
			<form onSubmit={this.onSubmit}>
			<h1 className="title">Nonconformity</h1>
			<Grid container direction="column" alignItems="stretch" justify="flex-start" spacing={2} xs={12}>
				<Grid item xs={12}>
					Order id: {this.props.orderId}{ncIdDesc}
				</Grid>
				<Grid item>
					<TextField
						id="title"
						name="title"
						label="Title: "
						defaultValue={this.props.title}
						margin="normal"
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid item xs={12}>Description</Grid>
				<Grid item>
					<textarea
						label="Description: "
						onChange={this.handleChange}
						style={{width: "100%"}}
						rows="4"
						id="description"
						name="description"
						value={this.state.description}
					/>
				</Grid>
				{this.props.id>0 ? <Grid item xs={12}>Corrective action</Grid> : ""}
				{this.correctiveAction()}
			</Grid>
			{this.formButtons()}
			</form>
			</div>
		);
	}
}

export default NonconformityForm;